import { AuthenticationResult } from '@azure/msal-browser';
import { msalInstance } from './msalInstance';

let bootstrapComplete = false;
let redirectResult: AuthenticationResult | null = null;

/** Result of the first handleRedirectPromise() call during app bootstrap. */
export function getMsalRedirectResult(): AuthenticationResult | null {
  return redirectResult;
}

export async function bootstrapMsal(): Promise<void> {
  if (bootstrapComplete) {
    return;
  }

  await msalInstance.initialize();

  try {
    // Must run once at startup. Capture the result so /sso-callback can still
    // create the app session after this promise has been consumed.
    redirectResult = await msalInstance.handleRedirectPromise({
      navigateToLoginRequestUrl: false,
    });
    if (redirectResult?.account) {
      msalInstance.setActiveAccount(redirectResult.account);
    }
  } catch (error) {
    console.error('MSAL handleRedirectPromise during bootstrap failed:', error);
    redirectResult = null;
  }

  bootstrapComplete = true;
}
